import React from 'react';


const AttributeHeader = function AttributeHeaderComponent() {
  return (
    <div className="attribute-selector-header__container">
      <span className="attribute-selector-header__upper">
        Update your service type
      </span>
      <div className="attribute-selector-header__title">
        Get instant rebates and offers available to you
      </div>
    </div>
  );
};

export default AttributeHeader;
